import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ReactNode } from 'react';
import { Header } from '../../components/layout/main-layout';

interface EmptyDetailsProps {
  title?: string;
  content?: string | ReactNode;
  backLink?: ReactNode;
}

const useStyles = makeStyles({
  emptyContainer: {
    flexGrow: 1,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  content: {
    padding: 40,
  },
});

function EmptyDetails({
  title = 'Not found',
  content = 'Oops... Something went wrong, we did not find the element you requested',
  backLink,
}: EmptyDetailsProps) {
  const classes = useStyles();

  return (
    <>
      <Header title={title} backLink={backLink} />
      <Paper className={classes.emptyContainer} elevation={1}>
        <div className={classes.content}>{content}</div>
      </Paper>
    </>
  );
}

export default EmptyDetails;
